import request from '@/utils/request';

//等级变化历史
export function getGradeChange({
  page: pageNum,
  limit: pageSize,
  member_id: memberId,
}) {
  return request('/member/queryLevelPage', {
    // return request('/getGradeChange', {
    method: 'POST',
    data: {
      pageNum,
      pageSize,
      memberId,
    },
  });
}

//经验列表
export function getExperienceChange(values) {
  return request('/membership/exps', {
    // return request('/getGradeChange', {
    method: 'GET',
    params: values,
  });
}
//优惠券记录列表
export function getCouponRecordList(values) {
  console.log('values', values);
  // return request('/membership/exps', {
  return request('/coupon/queryConsumeList', {
    method: 'POST',
    data: values,
  });
}
//会员详情mock
export function getMemberDetail(values) {
  const { memberID, memberCode, mobile } = values || {};
  return request('/member/queryMemberInfo', {
    method: 'POST',
    data: {
      id: memberID,
      memberCode,
      mobile,
    },
  });
}
//编辑会员详情
export function editMember(values) {
  const { memberID } = values || {};
  delete values.memberID;
  return request(`/membership/members/${memberID}`, {
    // return request('/getMemberDetail', {
    method: 'PUT',
    // params: values,
    data: values,
  });
}
//积分历史mock
export function getIntegralHistory({
  page: pageNum,
  limit: pageSize,
  member_id: memberId,
}) {
  return request('/member/queryPointPage', {
    // return request('/getIntegralHistory', {
    method: 'POST',
    data: {
      pageNum,
      pageSize,
      memberId,
    },
  });
}
//绑定变化记录
export function getBindRecord(values) {
  // const { memberID } = values || {};
  // delete values.memberID;
  // return request(`/membership/members/${memberID}/identities`, {
  return request('/member/queryIdentityHistoryList', {
    method: 'POST',
    data: {
      id: values.member_id,
    },
  });
}
//基础信息mock
export function getBasicInformation() {
  // const { memberID } = values || {};
  // delete values.memberID;
  return request('/getBasicInformation', {
    // return request(`/membership/members/${memberID}/identities`, {
    method: 'GET',
    // params: values,
  });
}
//消费记录mock
export function getConsumptionRecord(data) {
  // const { memberID } = values || {};
  // delete values.memberID;
  // return request('/getConsumptionRecord', {
  return request('/order/queryMemberOrderPage', {
    method: 'POST',
    data,
  });
}

//消费记录查看详情
export function getConsumptionRecordDetail(values) {
  const { memberID } = values || {};
  // delete values.memberID;
  // return request('/getConsumptionRecord', {
  return request(`/order/orders/${memberID}`, {
    method: 'GET',
    // params: values,
  });
}

// 弹窗
//会员层级mock
export function apiChart1(id) {
  return request(`/members/${id}/dashboard/summary`, {
    method: 'GET',
    // params: values,
  });
}
export function apiChart2(id) {
  return request(`/members/${id}/dashboard/point`, {
    method: 'GET',
    // params: values,
  });
}
export function apiChart3(id) {
  return request(`/members/${id}/dashboard/point-channel`, {
    method: 'GET',
  });
}
export function apiChart4(id) {
  return request(`/members/${id}/dashboard/consumption-channel`, {
    method: 'GET',
  });
}
export function apiChart5(id) {
  return request(`/members/${id}/dashboard/journey`, {
    method: 'GET',
  });
}
export function apiChart6(id) {
  return request(`/members/${id}/dashboard/consumption`, {
    method: 'GET',
  });
}
